var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHospitalBritnicoHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45.422,
    height: 45.713,
    viewBox: "0 0 45.422 45.713",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hospital_Brit\\xE1nico_Home",
    "data-name": "Hospital Brit\\xE1nico Home",
    transform: "translate(15292.57 333)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_150085",
    "data-name": "Rect\\xE1ngulo 150085",
    width: 38.694,
    height: 24.506,
    transform: "translate(-15288.99 -312.793)",
    fill: "#fff",
    stroke: "#05294f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_150084",
    "data-name": "Rect\\xE1ngulo 150084",
    transform: "translate(-15292 -315.803)",
    fill: "#fff",
    stroke: "#05294f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.853,
    height: 6.019,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 41.853,
    height: 4.019,
    rx: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_150092",
    "data-name": "Rect\\xE1ngulo 150092",
    transform: "translate(-15289.421 -296.026)",
    fill: "#fff",
    stroke: "#05294f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill",
    width: 39.553,
    height: 1.72,
    rx: 0.86,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.7197171449661255h39.55349349975586M38.55349349975586,0v1.7197171449661255M39.55349349975586,1h-39.55349349975586M1,1.7197171449661255v-1.7197171449661255",
    fill: "none",
    clipPath: "url(#clip)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_150083",
    "data-name": "Rect\\xE1ngulo 150083",
    width: 22.356,
    height: 39.553,
    transform: "translate(-15281.252 -327.841)",
    fill: "#fff",
    stroke: "#05294f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_98397",
    "data-name": "Trazado 98397",
    d: "M-15232.571-280.047h43.422",
    transform: "translate(-58.999 -8.281)",
    fill: "none",
    stroke: "#05294f",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_150082",
    "data-name": "Rect\\xE1ngulo 150082",
    transform: "translate(-15285.121 -333)",
    fill: "#fff",
    stroke: "#05294f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.095,
    height: 6.019,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28.095,
    height: 4.019,
    rx: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_98398",
    "data-name": "Trazado 98398",
    d: "M-15278.993-309.5h23.217",
    transform: "translate(-2.259 -3.293)",
    fill: "none",
    stroke: "#05294f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_150086",
    "data-name": "Rect\\xE1ngulo 150086",
    width: 12.038,
    height: 11.178,
    transform: "translate(-15276.093 -299.466)",
    fill: "#fff",
    stroke: "#05294f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_98399",
    "data-name": "Trazado 98399",
    d: "M-15266-299.642v11.286",
    transform: "translate(-4.074 -0.079)",
    fill: "none",
    stroke: "#05294f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_1",
    "data-name": "Uni\\xF3n 1",
    d: "M2.866,8.6V5.732H0V2.866H2.866V0H5.732V2.866H8.6V5.732H5.732V8.6Z",
    transform: "translate(-15274.373 -324.831)",
    fill: "#fff",
    stroke: "#05294f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_165894",
    "data-name": "Grupo 165894",
    transform: "translate(-15278.672 -308.064)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_150089",
    "data-name": "Rect\\xE1ngulo 150089",
    width: 3.566,
    height: 3.566,
    rx: 0.2,
    fill: "#fff",
    stroke: "#05294f",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_150090",
    "data-name": "Rect\\xE1ngulo 150090",
    width: 3.566,
    height: 3.566,
    rx: 0.2,
    transform: "translate(6.879)",
    fill: "#fff",
    stroke: "#05294f",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_150091",
    "data-name": "Rect\\xE1ngulo 150091",
    width: 3.566,
    height: 3.566,
    rx: 0.2,
    transform: "translate(13.758)",
    fill: "#fff",
    stroke: "#05294f",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalBritnicoHome);
export default __webpack_public_path__ + "static/media/Hospital Británico Home.d6118bd3de07c02ba426f046b01020fd.svg";
export { ForwardRef as ReactComponent };